/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './product';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "WarrantyStatus": {
                    "values": {
                      "ALLOTTED": 1,
                      "ALLOTMENT_REQUIRED": 2,
                      "ELIGIBLE": 3,
                      "TAMPERED": 4,
                      "CLAIMED": 5,
                      "EXPIRED": 6,
                      "REPLACEMENT": 7
                    }
                  },
                  "WarrantyPeriod": {
                    "values": {
                      "SIX_MONTHS": 1,
                      "ONE_YEAR": 2,
                      "TWO_YEARS": 3
                    }
                  },
                  "WarrantyProduct": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "productKey": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "serialNumber": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "serialPattern": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "warrantyExpires": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "serviceCloudCaseNumber": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "warrantyOrderNumber": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "status": {
                        "type": "squareup.solidshop.v2.resources.WarrantyStatus",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  },
                  "WarrantyReason": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayText": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "WarrantyProductDetail": {
                    "fields": {
                      "warrantyReasons": {
                        "type": "squareup.solidshop.v2.resources.WarrantyReason",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "warrantyPeriod": {
                        "type": "squareup.solidshop.v2.resources.WarrantyPeriod",
                        "id": 2,
                        "rule": "optional"
                      },
                      "selfServe": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "endOfLife": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "effa": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "product": {
                        "type": "squareup.solidshop.v2.resources.Product",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE WarrantyStatus @ squareup/solidshop/v2/resources/warranty_product.proto at 11:1
 */
export const WarrantyStatus = $root.lookupEnum('squareup.solidshop.v2.resources.WarrantyStatus').values;
/**
 * SOURCE WarrantyPeriod @ squareup/solidshop/v2/resources/warranty_product.proto at 34:1
 */
export const WarrantyPeriod = $root.lookupEnum('squareup.solidshop.v2.resources.WarrantyPeriod').values;
/**
 * --
 * WarrantyProducts can have several origins:
 * - Device exists in Tarkin, is the sole source of truth
 * - Device exists in Tarkin and has warranty allotment(s)
 * - Exists as a warranty allotment only (from "Add Device" flow)
 * - Is an accessory (always shown to merchants)
 * --
 *
 * SOURCE WarrantyProduct @ squareup/solidshop/v2/resources/warranty_product.proto at 52:1
 */
export const WarrantyProduct = $root.lookupType('squareup.solidshop.v2.resources.WarrantyProduct');
fixType(WarrantyProduct);
Builder.createAndAttachToType(WarrantyProduct);
/**
 * Can be used for customer facing and regulator override reasons
 *
 * SOURCE WarrantyReason @ squareup/solidshop/v2/resources/warranty_product.proto at 79:1
 */
export const WarrantyReason = $root.lookupType('squareup.solidshop.v2.resources.WarrantyReason');
fixType(WarrantyReason);
Builder.createAndAttachToType(WarrantyReason);
/**
 * SOURCE WarrantyProductDetail @ squareup/solidshop/v2/resources/warranty_product.proto at 87:1
 */
export const WarrantyProductDetail = $root.lookupType('squareup.solidshop.v2.resources.WarrantyProductDetail');
fixType(WarrantyProductDetail);
Builder.createAndAttachToType(WarrantyProductDetail);
